import { getInfoIndus } from './indusPopupHelper';
import { getInfoH2s } from './h2sPopupHelper';
import { getInfoHydro } from './hydroPopupHelper';
import { getInfoPluie } from './pluiePopupHelper';
import { getInfoMilieuDilution, getInfoMilieuSensibility } from './milieuPopupHelper';
import { getInfoDo, getInfoTp } from './doTpPopupHelper';
import { getInfoPrMr } from './prMrPopupHelper';

export const Red =
  '<svg id="red-icon" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><circle fill="#FF0000" id="red-icon" cx="12.5" cy="12.5" r="6"></circle></svg>';
export const Orange =
  '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><circle fill="#FFBF66" id="orange-icon" cx="12.5" cy="12.5" r="6"></circle></svg>';
export const Blue =
  '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><circle fill="#008BD2" id="blue-icon" cx="12.5" cy="12.5" r="6"></circle></svg>';
export const Green =
  '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><circle fill="#76D19B" id="green-icon" cx="12.5" cy="12.5" r="6"></circle></svg>';
export const Grey =
  '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><circle fill="#BCBFC3" id="grey-icon" cx="12.5" cy="12.5" r="6"></circle></svg>';
export const Yellow =
  '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><circle fill="#cef810" id="yellow-icon" cx="12.5" cy="12.5" r="6"></circle></svg>';
export const Violet =
  '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><circle fill="#A500B5" id="violet-icon" cx="12.5" cy="12.5" r="6"></circle></svg>';
export const BLACK =
  '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><circle fill="#000000" id="black-icon" cx="12.5" cy="12.5" r="6"></circle></svg>';
export const logo =
  '<svg width="100px" height="100px" viewBox="0 0 121 120" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Site-Diagperm" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Site---Diag-360---popup-info-déversement" transform="translate(-205.000000, -51.000000)"><g id="Infos-bulles-map" transform="translate(22.000000, 21.000000)"><g id="illu/Cloud" transform="translate(183.000000, 30.000000)"> <path d="M67.578885,105.89954 C83.3705022,107.026783 100.854581,98.6355966 106.370643,82.340186 C111.778798,66.3615341 103.148966,47.022832 88.9749213,40.1409701 C74.8008735,33.2606375 57.1165516,38.1591812 46.1077671,50.2018787 C40.2352975,56.62608 35.9947076,65.0692245 35.1800358,74.11051 C34.7805243,78.5416734 34.936502,85.027293 36.782401,89.037053 C37.9893932,91.656231 39.4559118,94.1587295 41.3679719,96.2093025 C44.4058288,99.4722104 48.7365772,100.874739 52.6557525,102.43856 C57.4470929,104.351086 62.485086,105.535222 67.578885,105.89954" id="Fill-1" fill="#FFE0B3" transform="translate(71.500000, 71.500000) rotate(-210.000000) translate(-71.500000, -71.500000) "></path> <g id="001-sun" fill="#000000" fill-rule="nonzero"><path d="M40.5,63 C28.0934375,63 18,52.9065625 18,40.5 C18,28.0934375 28.0934375,18 40.5,18 C52.9065625,18 63,28.0934375 63,40.5 C63,52.9065625 52.9065625,63 40.5,63 Z M40.5,23 C30.8504687,23 23,30.8504687 23,40.5 C23,50.1495312 30.8504687,58 40.5,58 C50.1495312,58 58,50.1495312 58,40.5 C58,30.8504687 50.1495312,23 40.5,23 Z" id="Shape"></path>                        <path d="M40.5,12 C39.1192188,12 38,10.9254 38,9.6 L38,2.4 C38,1.0746 39.1192188,0 40.5,0 C41.8807812,0 43,1.0746 43,2.4 L43,9.6 C43,10.9254 41.8807812,12 40.5,12 Z" id="Path"></path><path d="M40.5,80 C39.1192188,80 38,78.9254 38,77.6 L38,70.4 C38,69.0746 39.1192188,68 40.5,68 C41.8807812,68 43,69.0746 43,70.4 L43,77.6 C43,78.9254 41.8807812,80 40.5,80 Z" id="Path"></path><path d="M77.6,43 L70.4,43 C69.07445,43 68,41.880625 68,40.5 C68,39.119375 69.07445,38 70.4,38 L77.6,38 C78.92555,38 80,39.119375 80,40.5 C80,41.880625 78.92555,43 77.6,43 Z" id="Path"></path><path d="M9.6,43 L2.4,43 C1.07445,43 0,41.880625 0,40.5 C0,39.119375 1.07445,38 2.4,38 L9.6,38 C10.92555,38 12,39.119375 12,40.5 C12,41.880625 10.92555,43 9.6,43 Z" id="Path"></path><path d="M61.4283926,21 C59.2867671,21 58.1806295,18.3907126 59.7132426,16.8578358 L64.8589959,11.7106881 C65.8063991,10.7631798 67.3423476,10.7630281 68.2894476,11.7106881 C69.2368508,12.6581964 69.2368508,14.1945611 68.2894476,15.1420694 L63.1436943,20.2892171 C62.6699168,20.7631229 62.0490789,21 61.4283926,21 L61.4283926,21 Z" id="Path"></path><path d="M13.4283926,69 C11.2867671,69 10.1806295,66.3906977 11.7132426,64.8578123 L16.8589959,59.7106353 C17.8065507,58.7631216 19.3424992,58.7631216 20.2894476,59.7106353 C21.2368508,60.658149 21.2368508,62.1945224 20.2894476,63.1420361 L15.1435427,68.2893647 C14.6699168,68.7629699 14.0492305,69 13.4283926,69 Z" id="Path"></path><path d="M66.5715348,69 C65.9506904,69 65.3299976,68.7631207 64.8563668,68.289362 L59.7105598,63.1421655 C58.7631467,62.1944966 58.7631467,60.658269 59.7105598,59.7107517 C60.6578213,58.7630828 62.1937858,58.7630828 63.1410473,59.7107517 L68.2868543,64.8579482 C69.8193318,66.3905362 68.7131826,69 66.5715348,69 L66.5715348,69 Z" id="Path"></path><path d="M18.5716074,21 C17.9507695,21 17.3300832,20.7631207 16.8564573,20.289362 L11.7105524,15.1421655 C10.7631492,14.1944966 10.7631492,12.658269 11.7105524,11.7107517 C12.657804,10.7630828 14.1937525,10.7630828 15.1410041,11.7107517 L20.2867574,16.8579482 C21.8193705,18.3906879 20.7132329,21 18.5716074,21 Z" id="Path"></path> </g></g></g></g></g></svg>';

export function getColor(measureColor) {
  let color = Grey;

  switch (measureColor) {
    case 'VIOLET': {
      color = Violet;
      break;
    }
    case 'ROUGE':
    case 4: {
      color = Red;
      break;
    }
    case 'ORANGE':
    case 3: {
      color = Orange;
      break;
    }
    case 'YELLOW':
    case 2: {
      color = Yellow;
      break;
    }
    case 'BLEU': {
      color = Blue;
      break;
    }
    case 'VERT':
    case 1: {
      color = Green;
      break;
    }
    case null: {
      color = Grey;
      break;
    }
    default: {
      break;
    }
  }
  return color;
}

export const convertAssDomestique = (pValue: string) => {
  if (pValue === '1') {
    return 'Oui';
  } else {
    return 'Non';
  }
};

// Define a helper function to get time measure and color
export function getTimeMeasureAndColor(tfct, dayLimit) {
  const measure =
    tfct.measure < 24 ? `${Math.round(100 * tfct.measure) / 100}h` : '24h';

  if (measure === '24h') {
    dayLimit = true;
  }

  return { measure, color: getColor(tfct.colorLabel) };
}

// Define a helper function to get number measure and color
export function getNumberMeasureAndColor(nbdempr, thousandLimit) {
  const measure =
    nbdempr === null
      ? 'NR'
      : nbdempr.measure < 1000
      ? (Math.round(100 * nbdempr.measure) / 100).toString()
      : '1 000';

  if (measure === '1 000') {
    thousandLimit = true;
  }

  return { measure, color: getColor(nbdempr !== null && nbdempr.colorLabel) };
}

export const getContentPopup = async (pIndicator: string, pLayerName: string) => {  
  switch (pIndicator) {
    case 'do':
      return await getInfoDo;
    case 'tp':
      return await getInfoTp;
    case 'pr':
      return await getInfoPrMr;
    case 'h2s':
      return await getInfoH2s;
    case 'indus':
      return await getInfoIndus;
    case 'hydro':
      return await getInfoHydro;
    case 'pluie':
      return await getInfoPluie;
    case 'milieu':
      if (pLayerName.includes('Sensibilité') === false) {
        return await getInfoMilieuDilution;
      } else {
        return await getInfoMilieuSensibility;
      }
    default:
      return null;
  }
};

export const getIndicatorForPopup = (pPopupType: string, pFeature: any) => {
  if (pPopupType !== 'do') {
    return pPopupType;
  } else {
    return pFeature.attributes['ModelCode'] === 'MDI_PR,TP' ? 'tp' : 'do';
  }
};

// Get popup PR TP values function
export const getTpValues = (
  data: { variableName: string },
  dayLimit: boolean,
  returnedTpValues: { tp: string; tpColor: string; pName: any }[],
) => {
  const { measure, color } = getTimeMeasureAndColor(data, dayLimit);
  return returnedTpValues.push({
    tp: measure,
    tpColor: color,
    pName: data.variableName.slice(1),
  });
};

// Get popup PR NP values function
export const getNpValues = (
  data: { variableName: string },
  thousandLimit: boolean,
  returnedNpValues: { np: string; npColor: string; pName: any }[],
) => {
  const { measure, color } = getNumberMeasureAndColor(data, thousandLimit);
  return returnedNpValues.push({
    np: measure,
    npColor: color,
    pName: data ? data.variableName.slice(1) : null,
  });
};

// Get measure values function
export const getMeasureValue = (
  calculRound: number | 'NR',
  measure: number,
) => {
  return calculRound === 0
    ? measure
    : calculRound === 'NR'
    ? 'NR'
    : calculRound;
};

// Calcul Round Value function
export const calculRoundValue = (measure: number | null) => {
  return measure !== null ? Math.round(100 * measure) / 100 : 'NR';
};

// Get displayed indicator names function
export const displayedIndicator = (indicatorModule: string): string => {
  switch (indicatorModule) {
    case 'IndicatorBoonLister':
      return 'Boon&Lister';
    case 'IndicatorSejourCana':
      return 'Tps séjour cana';
    case 'IndicatorSejourPR':
      return 'Tps séjour PR';
    case 'IndicatorAutocurage':
      return 'Vit autocurage';
    default:
      return 'Terrain';
  }
};
